// extracted by mini-css-extract-plugin
module.exports = {"container":"Progress_container__R1NuU","completed":"Progress_completed__mup_X","failed":"Progress_failed__Tlc17"};